export enum ActionType {
    INIT_STORE = 'FUTURIZE_LMS/initStore',
    CHANGE_INPUT = 'FUTURIZE_LMS/changeInput',
    GET_CAPTCHA = 'FUTURIZE_LMS/getCaptcha',
    HANDLE_CAPTCHA_RESPONSE = 'FUTURIZE_LMS/handleCaptchaResponse',
    SUBMIT_FORM = 'FUTURIZE_LMS/submitForm',
    HANDLE_LMS_RESPONSE = 'FUTURIZE_LMS/handleLMSResponse',
}

export enum FormInputType {
    CONTROL = 'control',
    ELEMENT_BLOCK = 'element_block',
}

export enum ContactMethod {
    CALL_BACK = 'Call back',
    CONSULT_AT_HOME = 'Consult at home',
    EMAIL = 'Email notification',
}

export enum EventString {
    CLICK = 'click',
    MOUSE_DOWN = 'mousedown',
    CHANGE = 'change',
}

export enum CaptchaMediaType {
    HEADER_IMAGE = 'image/jpeg',
    HEADER_AUDIO = 'audio/wav',
}

export enum FormStatus {
    START = 'start',
    SUCCESS = 'success',
    FAILURE = 'failure',
}

export enum ConsentName {
    PRIVACY_NOTICE = 'privacyNotice',
}

export enum ValidatorErrorKey {
    REQUIRED = 'required',
    ONLY_NUMBERS = 'onlyNumbers',
    SECURE_VALUE = 'secureValue',
    EMAIL = 'email',
    MAX_LENGTH_CITY = 'maxLengthCity',
    MAX_LENGTH_STREET = 'maxLengthStreet',
    MAX_LENGTH_HOUSE = 'maxLengthHouseNumber',
    MAX_LENGTH_ZIP = 'maxLengthZipcode',
    MAX_LENGTH_MOBILE = 'maxLengthMobile',
    MAX_LENGTH_70 = 'maxLength70',
    MAX_LENGTH_800 = 'maxLength800',
    MIN_LENGTH_ZIP = 'minLengthZipcode',
    MIN_LENGTH_MOBILE = 'minLengthMobile',
}

export enum DXLErrorCode {
    METHOD_ARGUMENT_NOT_VALID = 'general.E400T_METHOD_ARGUMENT_NOT_VALID',
    MISSING_ONE_MANDATORY_FIELD = 'fs-tmf-sales-management.E400F_MISSING_ONE_MANDATORY_FIELD',
    MISSING_MANDATORY_FIELD = 'fs-tmf-sales-management.E400F_MISSING_MANDATORY_FIELD',
    NO_CONTACT_ADDED = 'fs-tmf-sales-management.E400F_NO_CONTACT_ADDED',
    INVALID_FIELD_VALUE = 'fs-tmf-sales-management.E400F_INVALID_FIELD_VALUE',
    BAD_REQUEST = 'fs-tmf-sales-management.E400F_BAD_REQUEST',
    BAD_REQUEST_CAPTCHA = 'js-captcha.E400F_BAD_REQUEST',
    INVLAID_PHONE_NUMBER = 'libdxlphonenumber.E400F_INVALID_PHONE_NUMBER',
}

export enum TrackingErrorType {
    TECHNICAL = 'technical',
    VALIDATION = 'validation',
}
